;var jcms = jcms ? jcms : config;

/**
 * Listener for breakpoint triggers
 *
 * Uses #jonah-mq-listener styling to trigger listener
 *
 * Create breakpoints scss map
 * $breakpoints: (
 *   "xlarge"       : $bp-xlarge,
 *   "large"        : $bp-large,
 *   "medium"       : $bp-medium,
 *   "small"        : $bp-small,
 *   "fluid"        : $bp-fluid,
 *   "fluid-medium" : $bp-fluid-medium,
 *   "fluid-small"  : $bp-fluid-small,
 *   "fluid-xsmall" : $bp-fluid-xsmall
 * );
 *
 * Add styling for #jonah-mq-listener (uses map-get-next function in Bitbucket snippets)
 * #mq-listener {
 *   position: absolute;
 *   bottom: 0;
 *   right: 0;
 *   width: 1px;
 *   transition: width .001s;
 *
 *   &::after {
 *     content: '#{$bp-xlarge}__xxlarge';
 *     display: block;
 *     position: absolute;
 *     height: 1px;
 *     width: 1px;
 *     overflow: hidden;
 *   }
 *
 *   $temp-min-width: '';
 *   @each $breakpoint, $value in $breakpoints {
 *     $temp-min-width: map-get-next($breakpoints, $breakpoint);
 *     @if $temp-min-width == false {
 *       $temp-min-width: '0px';
 *     }
 *
 *     @media (max-width: #{$value}) {
 *       width: round($value / 100);
 *
 *       &::after {
 *         content: '#{$temp-min-width}_#{$value}_#{$breakpoint}';
 *       }
 *     }
 *   }
 * }
 *
 * Script call example:
 * jonah.breakpointListener.registerCallback(function() {
 *   $.lazyload.reobserveLoadedAssets();
 * }, true);
 *
 */

(function($, jcms) {
  'use strict';

  jcms.breakpointListener = {
    callbacks : [],
    currentBreakpoint : "",
    registerCallback : function(callback, id) {
      this.callbacks.push(callback);
      if (id) {
        callback(jcms.breakpointListener.currentBreakpoint);
      }
    },
    init : function() {
      var element = document.createElement("div");
      element.id = "jonah-mq-listener";
      element.setAttribute("aria-hidden", "true");
      document.body.appendChild(element);

      var update = function() {
        var value = window.getComputedStyle(document.getElementById(element.id), '::after').getPropertyValue("content").replace(/"|'/g, "");
        if (value !== void 0) {
          for (var i = 0; i < jcms.breakpointListener.callbacks.length; i++) {
            jcms.breakpointListener.callbacks[i](value);
          }
        }
        jcms.breakpointListener.currentBreakpoint = value;
      };

      if (document.attachEvent) {
        window.addEventListener("resize", update, true);
      }
      else {
        element.addEventListener("webkitTransitionEnd", update, true);
        element.addEventListener("MSTransitionEnd", update, true);
        element.addEventListener("oTransitionEnd", update, true);
        element.addEventListener("transitionend", update, true);
      }
      update();
    }
  };
})(window.jQuery, jcms);
